import {observer} from "mobx-react";
import React from "react";
import {useBetween} from "use-between";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {useModalChat} from "@dropDesk/presentation/pages/chat/ui/modals/visible_modal_search";
import {Container, ContainerForm} from "@dropDesk/presentation/pages/chat/ui/internal_chat/form/styled";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import HeaderModal from "@dropDesk/presentation/components/headers/header_modal";
import {InternalChatEntity} from "@dropDesk/domain/entities/internal_chat/internal_chat_entity";
import {displayDateToLocale} from "@dropDesk/utils/helpers/date_helper";
import FooterModal from "@dropDesk/presentation/components/footer/footer_modal";
import {useValidatorInputInternalChat} from "@dropDesk/presentation/pages/chat/ui/internal_chat/form/inputs/validator";
import InputsFormInternalChat from "@dropDesk/presentation/pages/chat/ui/internal_chat/form/inputs/inputs";


const FormInternalChat = observer(
    ({
         loading,
         internalChat,
         onClickSave,
         onUpdate,
         onClickAddUser,
         onRemoveChip
     }: {
        loading: boolean
        internalChat: InternalChatEntity
        onClickSave: () => void
        onUpdate: (internalChat: InternalChatEntity) => void,
        onClickAddUser: () => void
        onRemoveChip: (idUser: string) => void
    }) => {

        const {
            setVisibleModalNewInternalChat,
        } = useBetween(useModalChat);

        const {
            errorMessageDescription,
            errorMessageUsers
        } = useValidatorInputInternalChat(internalChat, loading);

        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;

        return (
            <Container background={colors.onBackground}>
                <HeaderModal
                    disabled={loading}
                    letter={internalChat.isUnsaved() ? 'Cadastro de chat interno' : 'Editando chat interno'}
                    nameIcon={ICONS_DROPDESK.close}
                    onClick={() => setVisibleModalNewInternalChat(false)}
                />
                <ContainerForm>
                    <InputsFormInternalChat
                        internalChat={internalChat}
                        loading={loading}
                        onUpdate={onUpdate}
                        onClickAddUser={onClickAddUser}
                        onRemoveChip={onRemoveChip}
                    />
                </ContainerForm>
                <FooterModal
                    disabled={loading || !!errorMessageDescription || !!errorMessageUsers}
                    loading={loading}
                    type={"submit"}
                    letter={'Salvar'}
                    onSubmit={onClickSave}
                    onRequestClose={() => setVisibleModalNewInternalChat(false)}
                    createdAt={!internalChat.isUnsaved() ? `Criado em ${displayDateToLocale(internalChat!.createdAt!)}` : undefined}
                />
            </Container>
        )
    })
export default FormInternalChat;
